<template>
	<li
		v-if="card.contentType === 'ProductBase'"
		class="c-global-search-autosuggestions__item"
	>
		<a
			:href="card.url"
			@click="e => handleClick(e, card)"
			:ref="`card_${card.id}`"
			class="c-global-search-autosuggestions__product-link c-global-search-autosuggestions__product-link--no-underline h-focus-outline"
			data-testid="product-link"
			tabindex="-1"
		>
			<img
				:src="card.imageUrl"
				:alt="card.heading"
				class="c-global-search-autosuggestions__product-link-image"
			/>
			<div class="c-global-search-autosuggestions__product-link-text">
				<ds-text
					text-style="regular"
					text-type="body-xs"
					html-element="p"
					class="c-global-search-autosuggestions__product-color-muted"
					>{{ card.properties?.manufacturerName }}</ds-text
				>
				<ds-text
					text-style="bold"
					text-type="body-sm"
					html-element="h3"
					class="c-global-search-autosuggestions__product-color-default"
					>{{ card.heading }}</ds-text
				>

				<ds-text
					v-for="item in card.properties?.variantFieldsForAutoSuggest"
					:key="item"
					text-style="regular"
					text-type="body-xs"
					html-element="p"
					class="c-global-search-autosuggestions__product-color-muted"
					>{{ item }}</ds-text
				>
			</div>
		</a>
	</li>
	<li v-else class="c-global-search-autosuggestions__item">
		<a
			:href="card.url"
			@click="e => handleClick(e, card)"
			:target="card.contentType === 'PdfFile' ? '_blank' : null"
			class="c-global-search-autosuggestions__link c-global-search-autosuggestions__product-link--no-underline h-focus-outline"
			:ref="`card_${card.id}`"
			tabindex="-1"
		>

			<p v-if="card.categoryTags && card.categoryTags.value">
				{{ card.categoryTags.value }}
			</p>
			<h3 v-if="card.heading" class="c-global-search-autosuggestions__title">
				{{ card.heading }}
			</h3>
		</a>
	</li>
</template>

<script>
import { DsText } from '@coloplast/design-system';
import { mapActions, mapGetters } from 'vuex';

export default {
	name: 'global-search-autoSuggest-item',
	components: { DsText },
	props: ['card', 'selected', 'isProduct'],
	computed: {
		...mapGetters({
			lastSearchTerm: 'getLastSearchTerm'
		}),
	},
	methods: {
		...mapActions([
			'trackSearchClick'
		]),
		focusElement() {
			this.$refs[`card_${this.card.id}`].focus();
		},
		handleClick(e, card) {
			e.preventDefault();
			this.trackClick();

			if (this.isProduct) {
				this.$emit('itemClick', card)
			} else {
				const target = card.contentType === 'PdfFile' ? '_blank' : '_self';
				if (target === '_blank') {
					globalThis.open(card.url, '_blank');
				} else {
					globalThis.location.href = card.url;
				}
			}
		},
		trackClick() {
			this.trackSearchClick( { searchQuery: this.lastSearchTerm, itemGuid: this.card.guid });
		},
	},
	watch: {
		selected(newValue) {
			if (newValue) {
				this.focusElement();
			}
		},
	},
};
</script>
